export enum NdsSpinnerSize {
  DEFAULT = 'default',
  COMPACT = 'compact',
}
